import data_control from "../../../engines/libs/data_control";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../BundleResourceConfig";
import { clamShellEventMap, clamShellEndMap, clamShellEventInterface, clamShellEndInterface, clamShellStartInterface } from "../prefab/clamShellGame/clamShellConst";
import clamShellGameObj from "../prefab/clamShellGame/clamShellGameObj";
import { NormalBackpackI } from "./DefineInterface";
import NormalGameManager from "./NormalGameManager";

export default class clamShellManager{

    manager:NormalGameManager = null;

    constructor(manager:NormalGameManager){
        this.manager = manager;
        this.clamShellStartMap = new clamShellBasicMap();
        this.loadConfigs();
    }

    clamShellEventMap:clamShellEventMap = {};
    clamShellStartMap:clamShellBasicMap = {};
    clamShellEndMap :clamShellEndMap = {};

    clamShellEventJson = [];
    clamShellStartJson:clamShellStartInterface[] = [];
    clamShellEndJson = [];

    async loadConfigs(){
        return new Promise<void>(async resolve=>{
            let configArys:string[] = [
                "clamShellGameAssets/config/clamShellGameEventConfig",
                "clamShellGameAssets/config/clamShellGameStartConfig",
                "clamShellGameAssets/config/clamShellGameEndConfig"
            ]
            let bundle = await getOneBundle(BUNDLE_SMALL_NAME.clamShellGameBundle);
            bundle.load( configArys,cc.JsonAsset,(err,asset:cc.JsonAsset[])=>{
                if(err){
                    console.log("加载贝壳配置表失败",err);
                    this.clamShellEndMap = {};
                    return;
                }
                this.clamShellEventJson = asset[0].json;
                this.clamShellStartJson = asset[1].json;
                this.clamShellEndJson   = asset[2].json;

                for(let item of this.clamShellEventJson){
                    this.clamShellEventMap[item.id] = item;
                }

                for(let item of this.clamShellEndJson){
                    item = JSON.parse(JSON.stringify(item));
                    this.clamShellEndMap[item.id] = item;
                    if(item["Emergency"] == ""){
                        item["Emergency"] = [];
                    }else{
                        let s = item["Emergency"];
                        item["Emergency"] = JSON.parse(s);
                    }
                }
                for( let item of this.clamShellStartJson ){
                    //循环记录
                    let infoEntity : { id : number ,Gear : number , weight : number,explain:string , price:number ,bindBackId:number} = {
                        id : item['id'],
                        Gear : item["Gear"],
                        weight : item["weight"],
                        explain : item["explain"],
                        price : item["price"],
                        bindBackId: item["bindBackId"]
                    };
                    let basicEntity : clamShellBasicI = {
                        icon : item["icon"],
                        infoArray : [infoEntity]
                    };
                    //封装属性
                    if ( this.clamShellStartMap [ item["Gear"]] ) {
                        //如果存在
                        let gamblerBasicEntity = this.clamShellStartMap[item["Gear"]].find(( tempItem ,index ,dataList )=>{
                            return tempItem.icon == item["icon"];
                        });

                        if ( gamblerBasicEntity ) {
                            gamblerBasicEntity.infoArray.push( infoEntity );
                        }else{
                            this.clamShellStartMap[ item["Gear"]].push( basicEntity );
                        }
                    }else{
                        this.clamShellStartMap[item["Gear"]] = [];
                        this.clamShellStartMap[item["Gear"]].push( basicEntity );
                    }
                }
                //转换配置文件
                // console.log('gamblerStartJson', this.gamblerStartMap);
                resolve();
            });
        });
    }

    getOneClamShellRandEvent(clamShellGameObj:clamShellGameObj){
        let events = clamShellGameObj.endData.Emergency;
        return this.getRandEvent(events);
    }

    private getRandEvent(events:number[],eventMap:clamShellEventMap = this.clamShellEventMap){
        let weightAry:number[] = [];
        let eventAry:clamShellEventInterface[] = [];
        for(let i = 0;i<events.length;i++){
            let e = events[i];
            for(let k in eventMap){
                let ee = eventMap[k]
                let pro = ee.trigger_pro;
                if(ee.event_category == e){
                    eventAry.push(ee);
                    weightAry.push(pro);
                }
            }

        }
        let randIndex = data_control.getRandIPosByWeights(weightAry);
        let tEvent = eventAry[randIndex];
        return tEvent;
    }

    getOnePearlSpPath(clamShellGameObj:clamShellGameObj){
        let event = clamShellGameObj.event;
        let eventType = event.event_category;
        let str:string = null;
        switch(eventType){
            case 1:{

                break;
            }
            case 2:{

                break;
            }
            case 3:{

                break;
            }
            case 4:{

                break;
            }
        }
        return str;
    }

    getOneTypeEnd(type:number){
        let iType:string = type.toString();
        let endAry:clamShellEndInterface[] = [];
        for(let k in this.clamShellEndMap){
            let end = this.clamShellEndMap[k];
            if(end.ys_id == iType){
                endAry.push(end);
            }
        }
        let weightAry:number[] = [];
        for(let i =0;i<endAry.length;i++){
            let end = endAry[i];
            let endPro = end.pro;
            weightAry.push(endPro);
        }
        let index = data_control.getRandIPosByWeights(weightAry);
        return endAry[index];
    }

    getOneStartDataByBackpackItem(backpackItem:NormalBackpackI){
        let id = backpackItem.id;
        let startAry:clamShellStartInterface[] = [];
        for(let k in this.clamShellStartJson){
            let clam = this.clamShellStartJson[k];
            if(clam.bindBackId == id){
                startAry.push(clam);
            }
        }
        if(startAry.length > 0){
            let randItem = data_control.getRandItemOfArray(startAry);
            return randItem;
        }else{
            console.log(`背包物品：${backpackItem.name}未绑定蚌壳，请检查配置表 errCode:#clamShellManager`);
        }
        return null       
    }

}

/**
 * 基础Map
 */
export class clamShellBasicMap {
    [ gear : number] : clamShellBasicI[];
}
//基础接口
export interface clamShellBasicI {
    icon : string;
    infoArray : { id : number,Gear : number,weight : number,explain:string,price:number,bindBackId:number,}[],
}